"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelEmail = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelEmail = function SvgChannelEmail(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h120v120H0V0z",
    fill: "url(#sc_email__paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M71.401 60.359L95 75.278V44.81L71.4 60.359zM25 44.81v30.468l23.599-14.92L25 44.81zM90.625 35.938h-61.25c-2.183 0-3.916 1.627-4.244 3.723l34.87 22.973L94.868 39.66c-.328-2.096-2.06-3.724-4.244-3.724zM67.394 63.001l-6.19 4.078c-.368.24-.784.359-1.204.359-.42 0-.836-.119-1.203-.36l-6.19-4.081L25.14 80.37c.337 2.078 2.06 3.692 4.235 3.692h61.25c2.174 0 3.898-1.614 4.235-3.692L67.394 63.001z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_email__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#E41352"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#870000"
  }))));
};

exports.SvgChannelEmail = SvgChannelEmail;